import { render, staticRenderFns } from "./ExtratoArrematacao.vue?vue&type=template&id=d61c6458"
import script from "./ExtratoArrematacao.vue?vue&type=script&lang=js"
export * from "./ExtratoArrematacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports